import "./style.scss";

import Checkbox from "shared/ui/Checkbox";
import HeaderSection from "components/HeaderSection";
import { ReactComponent as IconArrowRight } from "assets/img/icons/icon_arrow-Right.svg";
import { ReactComponent as IconCheck } from "assets/img/icons/icon_Check.svg";
import { ReactComponent as IconInfo } from "assets/img/icons/icon_Info.svg";
import SidebarSlide from "components/SidebarSlide";
import { isBasicAccompanimentOffer } from "shared/config/pricings";
import { useState } from "react";

const StatusAccompagnement = ({ status, offreId }: { status: string, offreId: any }) => {
    const [slidebarIsOpen, setSlidebarIsOpen] = useState(false);

    const STEP_1 = 35, STEP_2 = 70, STEP_3 = 100;

    const getPercents = () => {
        if (isBasicAccompanimentOffer(offreId)) {
            return STEP_3;
        }
        switch (status) {
            case "Traitement du dossier":
                return STEP_1;
            case "Courriers envoyés":
                return STEP_2;
            case "ID Protect a reçu les AR":
                return STEP_3;
            default:
                return 0;
        }
    };
    const close = () => {
        setSlidebarIsOpen(false);
    };
    return (
        <>
            <HeaderSection
                title="Statut de la demande"
                number={getPercents()+ '%'}
            />
            <div className="StatusAccompagnement">

                {(!offreId || offreId !== 6) ? (
                  <>
                      <div
                        className={`StatusAccompagnement__step ${getPercents() >= STEP_1 ? "StatusAccompagnement__step__success" : "StatusAccompagnement__step__disabled"}`}>
                          <div
                            className="pointer"
                            onClick={() => setSlidebarIsOpen(true)}>
                              <IconInfo
                                fill="#12BC61"
                                width={16}
                              />
                          </div>
                          <span>Traitement du dossier</span>
                          {getPercents() >= STEP_1 && (
                            <IconCheck
                              fill="#12BC61"
                              width={14}
                            />
                          )}
                      </div>
                      <IconArrowRight
                        fill={`${getPercents() >= STEP_2 ? "#12BC61" : "#A3BBDC"}`}
                        width={20}
                      />
                      <div
                        className={`StatusAccompagnement__step ${getPercents() >= STEP_2 ? "StatusAccompagnement__step__success" : "StatusAccompagnement__step__disabled"}`}>
                          <span>Courriers envoyés ...</span>
                          {getPercents() > STEP_2 && (
                            <IconCheck
                              fill="#12BC61"
                              width={14}
                            />
                          )}
                      </div>
                      <IconArrowRight
                        fill={`${getPercents() >= STEP_3 ? "#12BC61" : "#A3BBDC"}`}
                        width={20}
                      />
                      <div
                        className={`StatusAccompagnement__step ${getPercents() >= STEP_3 ? "StatusAccompagnement__step__success" : "StatusAccompagnement__step__disabled"}`}>
                          <span>ID Protect a reçu les AR</span>
                          {getPercents() > STEP_3 && (
                            <IconCheck
                              fill="#12BC61"
                              width={14}
                            />
                          )}
                      </div>
                  </>
                ) :
                  (
                    <div className="flex-wrap d-flex flex-column">
                        <p className="mb-1">Voici quelques préconisations pour vous aider à continuer la procedure juridique.</p>
                        <ul>
                            <li>Vous devez adapter le courrier</li>
                            <li>Vous devez envoyer le courrier aux acteurs bancaires</li>
                        </ul>
                    </div>
                  )}
            </div>
            {slidebarIsOpen && (
              <SidebarSlide onClose={() => close()}>
                  <h3>Checklist</h3>
                  <p className="mb-2">Voici quelques préconisations pour vous aider à protéger votre identité.</p>
                  <Checkbox label="Déclarer la perte au commisariat" />
                  <Checkbox label="Vérifier ses comptes banquaires" />
                  <Checkbox label="Renouvellement des pièces d'identité" />
                  <Checkbox
                    label={
                        <a
                          rel="noreferrer"
                          href="https://www.service-public.fr/particuliers/vosdroits/F17608"
                                target="_blank">
                                Consulter le fichier FICP et usurpation de la banque de France
                            </a>
                        }
                    />
                    <Checkbox
                        label={
                            <a
                                rel="noreferrer"
                                href="https://www.cnil.fr/fr/demander-une-verification-sur-le-ficoba"
                                target="_blank">
                                Consulter le fichier Ficoba de la CNIL
                            </a>
                        }
                    />
                </SidebarSlide>
            )}
        </>
    );
};

export default StatusAccompagnement;
